export default {
  bot_name: 'Bot',
  closed_tickets: 'Tickets finalizados',
  average_attendance_time: 'Tiempo de atendimento',
  name: 'Tag',
};
